import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ShellModule, CrawfordControlsModule } from 'crawford-shell';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ExportGuardService } from './claim/claim-export/guard/export-guard.service';
import { ClaimModule } from './claim/claim.module';
import { ClaimService } from './claim/claim.service';
import { CommunicationService } from './communication/communication.service';
import { SavedSearchService } from './saved-search/saved-search.service';
import { UserDetailsResolver } from './user/resolvers/user-details.resolver';
import { UserService } from './user/user.service';
import { LossStatusesResolver } from './claim/claim-list/resolvers/loss-statuses.resolver';
import { SearchOperatorsResolver } from './claim/claim-list/resolvers/search-operators.resolver';
import { SearchFilterService } from './claim/claim-list/services/search-filter.service';
import { HttpInterceptorProviders } from './http-interceptors';
import { SessionExpiryComponent } from './session/session-expiry/session-expiry.component';
import { AccordionService } from './claim/claim-list/services/accordion.service';
import { ClaimDataSourcesResolver } from './claim/claim-list/resolvers/claim-data-sources.resolver';
import { ChangePasswordComponent } from './user/change-password/change-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExportService } from './claim/claim-export/service/export.service';
import { EventReportComponent } from './report/event-report/event-report.component';
import { ReportService } from './report/report.service';


@NgModule({
  declarations: [
    AppComponent,
    SessionExpiryComponent,
    ChangePasswordComponent,
    EventReportComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule,
    AppRoutingModule,
    ShellModule.forRoot(),
    HttpClientModule,
    ClaimModule,
    CrawfordControlsModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    HttpInterceptorProviders,
    ClaimService,
    ExportService,
    CommunicationService,
    ReportService,
    SearchFilterService,
    UserService,
    ExportGuardService,
    SavedSearchService,
    UserDetailsResolver,
    LossStatusesResolver,
    SearchOperatorsResolver,
    ClaimDataSourcesResolver,
    AccordionService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/app.module.ts